module.exports = __webpack_public_path__ + "img/rentagro.92bad68b.jpg";